"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParseQueryError = void 0;
var shared_1 = require("@cian/peperrors/shared");
var ParseQueryError = /** @class */ (function (_super) {
    __extends(ParseQueryError, _super);
    function ParseQueryError(message) {
        var _this = _super.call(this, { type: 'ParseQueryError', domain: 'http-api', message: message }) || this;
        if (Error.captureStackTrace) {
            Error.captureStackTrace(_this, ParseQueryError);
        }
        else {
            _this.stack = new Error().stack;
        }
        return _this;
    }
    return ParseQueryError;
}(shared_1.GenericError));
exports.ParseQueryError = ParseQueryError;
//# sourceMappingURL=ParseQueryError.js.map